module.exports = new __parcel__URL__("in-progress.213a56fe.png").toString();